module.exports = __webpack_public_path__ + "img/00020.597b1b2c.webp";